import React, { useContext } from "react";
import WindowSizeContext from "../../contexts/windowSizeContext";

export default (props) => {
  const windowSize = useContext(WindowSizeContext);

  return <p className={`${windowSize.isLargeScreenView ? `py-10 ` : `pv-4`} text-gray-900`}>{props.children}</p>;
};
